import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNugetComponent } from './simple-icons-nuget.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNugetComponent ],
    exports:      [ SimpleIconsNugetComponent ],
    bootstrap:    []
})
export class SimpleIconsNugetModule {}
